import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const DesktopIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 16 14" {...props}>
      <path
        d="M14.0013 0.333008H2.0013C1.26797 0.333008 0.667969 0.933008 0.667969 1.66634V9.66634C0.667969 10.3997 1.26797 10.9997 2.0013 10.9997H6.66797V12.333H5.33464V13.6663H10.668V12.333H9.33463V10.9997H14.0013C14.7346 10.9997 15.3346 10.3997 15.3346 9.66634V1.66634C15.3346 0.933008 14.7346 0.333008 14.0013 0.333008ZM14.0013 9.66634H2.0013V1.66634H14.0013V9.66634Z"
        fill="#1FD4AF"
      />
    </SvgIcon>
  );
};

export default DesktopIcon;
